import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import AnimPulse from '../atoms/animPulse'

const Ol = styled.ol`
  display: flex;
  width: 500px;
  margin: 30px auto 80px;

  li {
    list-style: none;
    position: relative;
    width: calc(100% / 3);
    text-align: center;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    &:after {
      background: #dcdee1;
      content: '';
      width: calc(100% - 24px);
      height: 4px;
      position: absolute;
      left: -72px;
      top: 11px;
    }

    &:first-child:after {
      display: none;
    }

    span {
      display: flex;
      position: relative;
      align-items: center;
      justify-content: center;
      line-height: 26px;
      border-radius: 50%;
      color: #dcdee1;
      z-index: 1;
      margin: 0 auto;
      text-align: center;
      border: solid 3px #dcdee1;
      background: #f8f8f8;
      width: 28px;
      height: 28px;
    }

    .pulse {
      display: none;
      justify-content: center;
    }

    p {
      margin: 10px 0 0;
      width: 100%;
    }
  }

  &.now-01 {
    li.step-01 {
      span {
        width: 24px;
        height: 24px;
        color: #ffffff;
        background: rgba(62, 199, 179, 0.1);
        border: none;
        z-index: 2;
      }

      .pulse {
        display: flex;
      }
    }
  }

  &.now-02 {
    li.step-02 {
      span {
        width: 24px;
        height: 24px;
        color: #ffffff;
        background: rgba(62, 199, 179, 0.1);
        border: none;
        z-index: 2;
      }

      .pulse {
        display: flex;
      }
    }
  }

  &.now-03 {
    li.step-03 {
      span {
        width: 24px;
        height: 24px;
        color: #ffffff;
        background: rgba(62, 199, 179, 0.1);
        border: none;
        z-index: 2;
      }

      .pulse {
        display: flex;
      }
    }
  }

  ${BreakPoints.medium} {
    width: 80%;
    min-width: 300px;

    li {
      &:after {
        width: calc(100% - 4px);
      }
    }
  }
`
type Props = {
  /** クラス名 */
  className?: string
}

/**
 * メールフォーム上部フロー図コンポーネント
 * @constructor
 */
const ContactFlow = (props: Props) => {
  const { className = '' } = props
  return (
    <Ol className={className}>
      <li className="step-01">
        <span>１</span>
        <AnimPulse className="pulse" />
        <p>入力</p>
      </li>
      <li className="step-02">
        <span>２</span>
        <AnimPulse className="pulse" />
        <p>内容確認</p>
      </li>
      <li className="step-03">
        <span>3</span>
        <AnimPulse className="pulse" />
        <p>完了</p>
      </li>
    </Ol>
  )
}

export default ContactFlow
